import React from "react"
import Layout from "../components/Layout"
import StyledHero from "../components/StyledHero"
//import { Link } from "gatsby"
import Banner from "../components/Banner"
import About from "../components/Home/About"
import Tips from "../components/Home/Tips"
import { graphql } from 'gatsby'
import AniLink from "gatsby-plugin-transition-link/AniLink"
import FeaturedPlaces from "../components/Home/FeaturedPlaces"
import SEO from "../components/SEO"
import CarouselList from '../components/Carousel/CarouselList'

export const query = graphql`
query {
    defaultBcg: file(relativePath: {eq: "defaultBcg.jpg"}) {
        childImageSharp {
            fluid(quality: 90, maxWidth: 4160) {
                ...GatsbyImageSharpFluid_withWebp
            }
        }
    }
}
`;

export default ({ data }) => (

    <Layout>
        <SEO title="Home" />
        <StyledHero home="true" img={data.defaultBcg.childImageSharp.fluid}>
            <Banner
                title="EscambiaSoft"
                info="Explore a sampling of solutions we have created from over 500+ projects done for various clients."
            >
                <AniLink paintDrip hex="#AEECEE" to="/places" className="btn-white">explore projects</AniLink>
            </Banner>
        </StyledHero>
        <br/>
        {/*<Carousel />*/}
        <CarouselList/>
        <About />
        <Tips />
        <FeaturedPlaces />
    </Layout>
)
